import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import ToolBar from '@mui/material/Toolbar';
import React from 'react';
import { useColorMode } from '../../../styles/ThemeSwitcher';

interface DefaultAppBarProps extends React.PropsWithChildren {
  title?: string
}

export const DefaultAppBar: React.FC<DefaultAppBarProps> = ({ children }) => {
  const theme = useTheme();
  const colorMode = useColorMode();
  return (
    <AppBar position="static">
      <ToolBar>
        <IconButton onClick={colorMode.toggleColorMode} color="inherit" size="small">
          {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
        {children}
      </ToolBar>
    </AppBar>
  );
};
